import React, { useEffect, useId, useState } from "react";
import mermaid from "mermaid";

mermaid.initialize({
    startOnLoad: false,
    securityLevel: "strict",
    theme: "default"
});

interface MermaidDiagramProps {
    code: string;
}

export const MermaidDiagram: React.FC<MermaidDiagramProps> = ({ code }) => {
    const reactId = useId();
    const [svg, setSvg] = useState("");
    const [error, setError] = useState(false);

    useEffect(() => {
        let active = true;
        const renderId = `ide-mermaid-${reactId.replace(/[^a-zA-Z0-9_-]/g, "")}`;

        setSvg("");
        setError(false);
        void mermaid.render(renderId, code).then(result => {
            if (active) setSvg(result.svg);
        }).catch(renderError => {
            console.error("Unable to render Mermaid diagram:", renderError);
            if (active) setError(true);
        });

        return () => {
            active = false;
        };
    }, [code, reactId]);

    if (error) {
        return (
            <div role="alert">
                <div>Unable to render this Mermaid diagram.</div>
                <pre><code className="language-mermaid">{code}</code></pre>
            </div>
        );
    }

    if (!svg) return <div aria-label="Rendering Mermaid diagram" />;

    return (
        <div
            className="ide-mermaid-diagram"
            dangerouslySetInnerHTML={{ __html: svg }}
        />
    );
};

export const MarkdownPre: React.FC<any> = ({ children, ...props }) => {
    const child = React.Children.count(children) === 1
        ? React.Children.only(children)
        : null;

    if (
        React.isValidElement<{ className?: string; children?: React.ReactNode }>(child) &&
        child.props.className?.split(/\s+/).includes("language-mermaid")
    ) {
        return <MermaidDiagram code={String(child.props.children || "").replace(/\n$/, "")} />;
    }

    return <pre {...props}>{children}</pre>;
};

